import { Injectable } from '@angular/core';

import { AuthGuard } from '@platform/auth/auth.guard';
import { CompositeGuard } from '@platform/routing/composite.guard';

import { CreateUserGuard } from './create-user.guard';

@Injectable({
  providedIn: 'root',
})
export class CreateUserCompositeGuard extends CompositeGuard {
  constructor(authGuard: AuthGuard, createUserGuard: CreateUserGuard) {
    super([authGuard, createUserGuard]);
  }
}
